<template>
    <CSidebar fixed color-scheme="info" :minimize="minimize" dropdown-mode="closeInactive" :show="show"
        @update:show="(value) => $store.commit('set', ['sidebarShow', value])">
        <CSidebarBrand class="d-md-down-none" style="text-decoration:none">
            <img src="https://www.bisigorta.com/_vercel/image?url=%2Fassets%2Fimage%2FbisigortaLogoLight.png&w=1536&q=100"
                alt="" style="width: auto; height: 40px;" to="/" />
        </CSidebarBrand>
        <CRenderFunction flat :content-to-render="navOptions" />
    </CSidebar>
</template>

<script>
import nav from './_nav';
import navPartner from './_navPartner';
import CRenderFunction from '../components/CRenderFunction.vue';

const packageJson = require('../../package.json');

export default {
    name: 'TheSidebar',
    components: {
        CRenderFunction
    },
    nav,
    navPartner,
    computed: {
        show() {
            return this.$store.state.sidebarShow
        },
        minimize() {
            return this.$store.state.sidebarMinimize
        }
    },
    data() {
        return {
            VUE_APP_NAME: process.env.VUE_APP_NAME,
            VUE_APP_URL: process.env.VUE_APP_URL,
            version: packageJson.version || 0,
            navOptions: this.$store.state.user.accountType === 'admin' ? this.$options.nav : this.$options.navPartner
        }
    },
    created() {
        console.log();
    }
}
</script>
